export default function FreeToUse() {

    return (
        <span className="sidebar-component">
            <div className="sidebar-component-text-container">
                <h3 className="info-left">FREE</h3>
                <p className="info-right">our quote system is 100% free to use.</p>
            </div>
        </span>
    )
}